import { Components, Theme } from "@mui/material/styles";

const MuiChip: Components<Theme>["MuiChip"] = {
  variants: [
    {
      props: { color: "grey" },
      style: {
        transition:
          "background-color 0.3s ease, box-shadow 0.3s ease, opacity 0.3s ease",
        color: "#212529",
        opacity: 0.9,
        backgroundColor: "#aca3a1",
        "&.MuiChip-clickable:hover": {
          backgroundColor: "#aca3a1",
          opacity: 1,
        },
        "&.Mui-disabled": {
          opacity: 0.5,
        },
        "&.chip-selected": {
          fontWeight: "bold",
          backgroundColor: "#b3b0a7",
          opacity: 0.9,
          boxShadow: `0 0 0 2px #000`,
          "&.MuiChip-clickable:hover": {
            backgroundColor: "#b3b0a7",
            opacity: 1,
          },
          "&.Mui-disabled": {
            opacity: 0.5,
          },
        },
      },
    },
    {
      props: { color: "red" },
      style: {
        transition:
          "background-color 0.3s ease, box-shadow 0.3s ease, opacity 0.3s ease",
        color: "#fff",
        opacity: 0.9,
        backgroundColor: "rgb(184, 111, 91)",
        "&.MuiChip-clickable:hover": {
          backgroundColor: "rgb(184, 111, 91)",
          opacity: 1,
        },
        "&.Mui-disabled": {
          opacity: 0.5,
        },
        "&.chip-selected": {
          fontWeight: "bold",
          backgroundColor: "rgb(168, 85, 63)",
          opacity: 0.9,
          boxShadow: `0 0 0 2px #000`,
          "&.MuiChip-clickable:hover": {
            backgroundColor: "rgb(168, 85, 63)",
            opacity: 1,
          },
          "&.Mui-disabled": {
            opacity: 0.5,
          },
        },
      },
    },
    {
      props: { color: "orange" },
      style: {
        transition:
          "background-color 0.3s ease, box-shadow 0.3s ease, opacity 0.3s ease",
        color: "#fff",
        opacity: 0.9,
        backgroundColor: "#e3a76f",
        "&.MuiChip-clickable:hover": {
          backgroundColor: "#e3a76f",
          opacity: 1,
        },
        "&.Mui-disabled": {
          opacity: 0.5,
        },
        "&.chip-selected": {
          fontWeight: "bold",
          backgroundColor: "#d6955d",
          opacity: 0.9,
          boxShadow: `0 0 0 2px #000`,
          "&.MuiChip-clickable:hover": {
            backgroundColor: "#d6955d",
            opacity: 1,
          },
          "&.Mui-disabled": {
            opacity: 0.5,
          },
        },
      },
    },
    {
      props: { color: "yellow" },
      style: {
        transition:
          "background-color 0.3s ease, box-shadow 0.3s ease, opacity 0.3s ease",
        color: "#212529",
        opacity: 0.9,
        backgroundColor: "#f1d99b",
        "&.MuiChip-clickable:hover": {
          backgroundColor: "#f1d99b",
          opacity: 1,
        },
        "&.Mui-disabled": {
          opacity: 0.5,
        },
        "&.chip-selected": {
          fontWeight: "bold",
          backgroundColor: "#e8cd85",
          opacity: 0.9,
          boxShadow: `0 0 0 2px #000`,
          "&.MuiChip-clickable:hover": {
            backgroundColor: "#e8cd85",
            opacity: 1,
          },
          "&.Mui-disabled": {
            opacity: 0.5,
          },
        },
      },
    },
    {
      props: { color: "green" },
      style: {
        transition:
          "background-color 0.3s ease, box-shadow 0.3s ease, opacity 0.3s ease",
        color: "#212529",
        opacity: 0.9,
        backgroundColor: "#8FBF93",
        "&.MuiChip-clickable:hover": {
          backgroundColor: "#8FBF93",
          opacity: 1,
        },
        "&.Mui-disabled": {
          opacity: 0.5,
        },
        "&.chip-selected": {
          fontWeight: "bold",
          backgroundColor: "#7FAA82",
          opacity: 0.9,
          boxShadow: `0 0 0 2px #000`,
          "&.MuiChip-clickable:hover": {
            backgroundColor: "#7FAA82",
            opacity: 1,
          },
          "&.Mui-disabled": {
            opacity: 0.5,
          },
        },
      },
    },
  ],
};

export default MuiChip;
